import React from 'react';
import './MdcOffer.css';
import bannerOfertas from '../../../assets/banner-ofertas.avif';
import bannerPagos from '../../../assets/banner-pagos.avif';

const VARIANTS = {
  Offer: {
    image: bannerOfertas,
    alt: 'Flor de cannabis en primer plano',
    align: 'left',
    eyebrow: 'Ofertas',
    title: 'Encontrá las mejores ofertas.',
    description: 'Descuentos y precios especiales que publican las tiendas.',
    cta: { label: 'Ver ofertas', href: '/productos' },
  },
  Mdc: {
    image: bannerPagos,
    alt: 'Plantas de cannabis vistas desde arriba',
    align: 'right',
    eyebrow: 'Medios de pago',
    title: 'Pagá como te quede más cómodo.',
    description: 'Cada tienda define sus medios de pago y sus formas de envío.',
    cta: { label: 'Consultanos', href: '/contacto' },
  },
};

const MdcOffer = ({ type }) => {
  const variant = VARIANTS[type] || VARIANTS.Offer;

  return (
    <section className={`mdc-offer mdc-offer-${variant.align}`}>
      <img className="mdc-offer-media" src={variant.image} alt={variant.alt} loading="lazy" />
      <div className="mdc-offer-scrim" />
      <div className="mdc-offer-body">
        <span className="mdc-offer-eyebrow">{variant.eyebrow}</span>
        <h3>{variant.title}</h3>
        <p>{variant.description}</p>
        <a className="mdc-offer-cta" href={variant.cta.href}>
          {variant.cta.label}
        </a>
      </div>
    </section>
  );
};

export default MdcOffer;
